import { createUseStyles } from '@pe-libs/react-components/build/theme';

const useStyles = createUseStyles('EmailError', (theme) => ({
  link: {
    color: theme.palette.common.white,
    textDecoration: 'underline',
    marginLeft: '0.25rem',
  },
}));

export default useStyles;
